
export const ALL_PTD_REQUEST = "ALL_PTD_REQUEST";
export const ALL_PTD_SUCCESS = "ALL_PTD_SUCCESS";
export const ALL_PTD_FAIL = "ALL_PTD_FAIL";